import { lazy } from 'react'

export const PreparePlan = lazy(() => import('./v1/PreparePlan'))
export const PreparePlanV2 = lazy(() => import('./v2/PreparePlanV2'))
